import type { TRouteObject } from "@ch/helpers/utils/types";
import BMIPageLazy from "@ch/pages/BMI";
import BloodGlucosePageLazy from "@ch/pages/BloodGlucosePage";
import BloodGlucoseHistoryPageLazy from "@ch/pages/BloodGlucosePage/BloodGlucoseHistoryPageLazy";
import BloodGlucoseLogPageLazy from "@ch/pages/BloodGlucosePage/BloodGlucoseLogPageLazy";
import BloodPressurePageLazy from "@ch/pages/BloodPressurePage";
import BloodPressureHistoryPageLazy from "@ch/pages/BloodPressurePage/BloodPressureHistoryPageLazy";
import BloodPressureLogPageLazy from "@ch/pages/BloodPressurePage/BloodPressureLogPageLazy";
import CholesterolPageLazy from "@ch/pages/CholesterolPage";
import CholesterolHistoryPageLazy from "@ch/pages/CholesterolPage/CholesterolHistoryPageLazy";
import CholesterolLogPageLazy from "@ch/pages/CholesterolPage/CholesterolLogPageLazy";
import ErrorPage from "@ch/pages/ErrorPage";
import ExercisePageLazy from "@ch/pages/ExercisePage";
import ExerciseHistoryPageLazy from "@ch/pages/ExercisePage/ExerciseHistoryPageLazy";
import Hba1cInputPageLazy from "@ch/pages/Hba1cInputPage";
import Hba1cInputHistoryPageLazy from "@ch/pages/Hba1cInputPage/Hba1cInputHistoryPageLazy";
import Hba1cInputLogPageLazy from "@ch/pages/Hba1cInputPage/Hba1cInputLogPageLazy";
import HealthDiaryPageLazy from "@ch/pages/HealthDiaryPage";
import HeightPageLazy from "@ch/pages/Height";
import HeightHistoryPageLazy from "@ch/pages/Height/HeightHistoryPageLazy";
import HeightLogPageLazy from "@ch/pages/Height/HeightLogPageLazy";
import NotFoundPage from "@ch/pages/NotFoundPage";
import PSAPageLazy from "@ch/pages/PSAPage";
import PSAHistoryPageLazy from "@ch/pages/PSAPage/PSAHistoryPageLazy";
import PSALogPageLazy from "@ch/pages/PSAPage/PSALogPageLazy";
import PregnancyPageLazy from "@ch/pages/PregnancyPage";
import TemperaturePageLazy from "@ch/pages/TemperaturePage";
import TemperatureHistoryPageLazy from "@ch/pages/TemperaturePage/TemperatureHistoryPageLazy";
import TemperatureLogPageLazy from "@ch/pages/TemperaturePage/TemperatureLogPageLazy";
import WaistCircumferencePageLazy from "@ch/pages/WaistCircumferencePage";
import WaistCircumferenceHistoryPageLazy from "@ch/pages/WaistCircumferencePage/WaistCircumferenceHistoryPageLazy";
import WaistCircumferenceLogPageLazy from "@ch/pages/WaistCircumferencePage/WaistCircumferenceLogPageLazy";
import WeightPageLazy from "@ch/pages/WeightPage";
import WeightLogPageLazy from "@ch/pages/WeightPage/WeightLogPageLazy";
import WeightPageHistoryPageLazy from "@ch/pages/WeightPage/WeightPageHistoryPageHistory";
import HeartRatePageLazy from "@ch/pages/HeartRatePage";
import HeartRateHistoryPageLazy from "@ch/pages/HeartRatePage/HeartRateHistoryPageLazy";
import HeartRateLogPageLazy from "@ch/pages/HeartRatePage/HeartRateLogPageLazy";
import { stepsRoutes } from "@ch/router/HealthDiaryRoutes/stepsRoutes.tsx";
import { respirationRoutes } from "@ch/router/HealthDiaryRoutes/respirationRoutes.tsx";
import { bloodOxygenRoutes } from "@ch/router/HealthDiaryRoutes/bloodOxygenRoutes.tsx";
import { hrvRoutes } from "@ch/router/HealthDiaryRoutes/hrvRoutes.tsx";
import { sleepRoutes } from "@ch/router/HealthDiaryRoutes/sleepRoutes.tsx";
import { stressRoutes } from "@ch/router/HealthDiaryRoutes/stressRoutes.tsx";
import { HealthDiaryPathsEnum, HealthDiaryRoutesEnum } from "./enums";

const HealthDiaryRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <HealthDiaryPageLazy />,
      },
      {
        path: HealthDiaryPathsEnum.CHOLESTEROL,
        element: <CholesterolPageLazy />,
        handle: {
          meta: () => ({
            title: "Cholesterol",
          }),
          crumb: () => ({
            title: "Cholesterol",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_CHOLESTEROL,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.CHOLESTEROL_LOG,
        element: <CholesterolLogPageLazy />,
        handle: {
          meta: () => ({
            title: "Log Cholesterol",
          }),
          crumb: () => ({
            title: "Log Cholesterol",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_CHOLESTEROL_LOG,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.CHOLESTEROL_HISTORY,
        element: <CholesterolHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Cholesterol History",
          }),
          crumb: () => ({
            title: "Cholesterol History",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_CHOLESTEROL_HISTORY,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.BLOOD_GLUCOSE,
        element: <BloodGlucosePageLazy />,
        handle: {
          meta: () => ({
            title: "Blood Glucose",
          }),
          crumb: () => ({
            title: "Blood Glucose",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_BLOOD_GLUCOSE,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.BLOOD_GLUCOSE_LOG,
        element: <BloodGlucoseLogPageLazy />,
        handle: {
          meta: () => ({
            title: "Log Blood Glucose",
          }),
          crumb: () => ({
            title: "Log Blood Glucose",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_BLOOD_GLUCOSE_LOG,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.BLOOD_GLUCOSE_HISTORY,
        element: <BloodGlucoseHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Blood Glucose History",
          }),
          crumb: () => ({
            title: "Blood Glucose History",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_BLOOD_GLUCOSE_HISTORY,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.EXERCISE,
        element: <ExercisePageLazy />,
        handle: {
          meta: () => ({
            title: "Exercise",
          }),
          crumb: () => ({
            title: "Exercise",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_EXERCISE,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.HBA1C,
        element: <Hba1cInputPageLazy />,
        handle: {
          meta: () => ({
            title: "HbA1c Input",
          }),
          crumb: () => ({
            title: "HbA1c Input",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_HBA1c_INPUT,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.HBA1C_LOG,
        element: <Hba1cInputLogPageLazy />,
        handle: {
          meta: () => ({
            title: "Log HbA1c Input",
          }),
          crumb: () => ({
            title: "Log HbA1c Input",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_HBA1c_INPUT_LOG,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.HBA1C_HISTORY,
        element: <Hba1cInputHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "HbA1c History",
          }),
          crumb: () => ({
            title: "HbA1c History",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_HBA1c_INPUT_HISTORY,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.EXERCISE_HISTORY,
        element: <ExerciseHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Exercise History",
          }),
          crumb: () => ({
            title: "Exercise History",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_EXERCISE_HISTORY,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.WAIST_CIRCUMFERENCE,
        element: <WaistCircumferencePageLazy />,
        handle: {
          meta: () => ({
            title: "Waist Circumference",
          }),
          crumb: () => ({
            title: "Waist Circumference",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_WAIST_CIRCUMFERENCE,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.PREGNANCY,
        element: <PregnancyPageLazy />,
        handle: {
          meta: () => ({
            title: "Pregnancy",
          }),
          crumb: () => ({
            title: "Pregnancy",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_PREGNANCY,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.BLOOD_PRESSURE,
        element: <BloodPressurePageLazy />,
        handle: {
          meta: () => ({
            title: "Blood Pressure",
          }),
          crumb: () => ({
            title: "Blood Pressure",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_BLOOD_PRESSURE,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.BLOOD_PRESSURE_LOG,
        element: <BloodPressureLogPageLazy />,
        handle: {
          meta: () => ({
            title: "Log Blood Pressure",
          }),
          crumb: () => ({
            title: "Log Blood Pressure",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_BLOOD_PRESSURE_LOG,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.BLOOD_PRESSURE_HISTORY,
        element: <BloodPressureHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Blood Pressure History",
          }),
          crumb: () => ({
            title: "Blood Pressure History",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_BLOOD_PRESSURE_HISTORY,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.BMI,
        element: <BMIPageLazy />,
        handle: {
          meta: () => ({
            title: "BMI",
          }),
          crumb: () => ({
            title: "BMI",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_BMI,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.WEIGHT,
        element: <WeightPageLazy />,
        handle: {
          meta: () => ({
            title: "Weight",
          }),
          crumb: () => ({
            title: "Weight",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_WEIGHT,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.WAIST_CIRCUMFERENCE_HISTORY,
        element: <WaistCircumferenceHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Waist Circumference History",
          }),
          crumb: () => ({
            title: "Waist Circumference History",
            route:
              HealthDiaryRoutesEnum.HEALTH_DIARY_WAIST_CIRCUMFERENCE_HISTORY,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.WAIST_CIRCUMFERENCE_LOG,
        element: <WaistCircumferenceLogPageLazy />,
        handle: {
          meta: () => ({
            title: "Log Waist Circumference",
          }),
          crumb: () => ({
            title: "Waist Circumference Log",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_WAIST_CIRCUMFERENCE_LOG,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.WEIGHT_HISTORY,
        element: <WeightPageHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Weight History",
          }),
          crumb: () => ({
            title: "Weight History",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_WEIGHT_HISTORY,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.WEIGHT_LOG,
        element: <WeightLogPageLazy />,
        handle: {
          meta: () => ({
            title: "Weight Log",
          }),
          crumb: () => ({
            title: "Log Weight",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_WEIGHT_LOG,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.PSA,
        element: <PSAPageLazy />,
        handle: {
          meta: () => ({
            title: "PSA",
          }),
          crumb: () => ({
            title: "PSA",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_PSA,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.PSA_HISTORY,
        element: <PSAHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "PSA History",
          }),
          crumb: () => ({
            title: "PSA History",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_PSA_HISTORY,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.PSA_LOG,
        element: <PSALogPageLazy />,
        handle: {
          meta: () => ({
            title: "PSA Log",
          }),
          crumb: () => ({
            title: "Log PSA",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_PSA_LOG,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.HEIGHT_HISTORY,
        element: <HeightHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Height History",
          }),
          crumb: () => ({
            title: "Height History",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_HEIGHT_HISTORY,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.HEIGHT_LOG,
        element: <HeightLogPageLazy />,
        handle: {
          meta: () => ({
            title: "Height Log",
          }),
          crumb: () => ({
            title: "Log Height",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_HEIGHT_LOG,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.HEIGHT,
        element: <HeightPageLazy />,
        handle: {
          meta: () => ({
            title: "Height",
          }),
          crumb: () => ({
            title: "Height",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_HEIGHT,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.TEMPERATURE_HISTORY,
        element: <TemperatureHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Temperature History",
          }),
          crumb: () => ({
            title: "Temperature History",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_TEMPERATURE_HISTORY,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.TEMPERATURE_LOG,
        element: <TemperatureLogPageLazy />,
        handle: {
          meta: () => ({
            title: "Temperature Log",
          }),
          crumb: () => ({
            title: "Log Temperature",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_TEMPERATURE_LOG,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.TEMPERATURE,
        element: <TemperaturePageLazy />,
        handle: {
          meta: () => ({
            title: "Temperature",
          }),
          crumb: () => ({
            title: "Temperature",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_TEMPERATURE,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.HEART_RATE_HISTORY,
        element: <HeartRateHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Heart Rate History",
          }),
          crumb: () => ({
            title: "Heart Rate History",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_HEART_RATE_HISTORY,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.HEART_RATE_LOG,
        element: <HeartRateLogPageLazy />,
        handle: {
          meta: () => ({
            title: "Heart Rate Log",
          }),
          crumb: () => ({
            title: "Log Heart Rate",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_HEART_RATE_LOG,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.HEART_RATE,
        element: <HeartRatePageLazy />,
        handle: {
          meta: () => ({
            title: "Heart Rate",
          }),
          crumb: () => ({
            title: "Heart Rate",
            route: HealthDiaryRoutesEnum.HEALTH_DIARY_HEART_RATE,
          }),
        },
      },
      ...stepsRoutes,
      ...respirationRoutes,
      ...bloodOxygenRoutes,
      ...hrvRoutes,
      ...sleepRoutes,
      ...stressRoutes,
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default HealthDiaryRoutes;
